import { render, staticRenderFns } from "./Shuibo.vue?vue&type=template&id=a175e10e&scoped=true&"
import script from "./Shuibo.vue?vue&type=script&lang=js&"
export * from "./Shuibo.vue?vue&type=script&lang=js&"
import style0 from "./Shuibo.vue?vue&type=style&index=0&id=a175e10e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a175e10e",
  null
  
)

export default component.exports